import { msalInstance, silentRedirectUri } from '../msalInstance';
import { apiTokenRequest } from '../authConfig';
import { requiresInteractiveConsent, triggerConsentRedirect } from '../utils/apiAuthHelper';

/**
 * Get Authorization headers for fetch-based API calls.
 * Returns empty object when API auth is not configured.
 */
export async function getAuthHeaders(): Promise<Record<string, string>> {
  if (!apiTokenRequest) return {};

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return {};

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...apiTokenRequest,
      account: accounts[0],
      redirectUri: silentRedirectUri,
    });
    return { Authorization: `Bearer ${response.accessToken}` };
  } catch (error) {
    if (requiresInteractiveConsent(error)) {
      await triggerConsentRedirect();
    }
    return {};
  }
}
